import axios from '../../plugins/axios'

export const createTask = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.post('/api/task', data, config)
    .then((response) => response )
    .catch((error) => error.response );
}

export const getTask = ({commit}, id) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.get(`/api/task/${id}`, config)
    .then((response) => {
      const task = response.data.task;
      commit('SET_TASK', { task });
    })
    .catch((error) => error.response );
}

export const deleteTask = ({}, id) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.delete(`/api/task/${id}`, config)
    .then((response) => response )
    .catch((error) => error.response );
}

export const editTask = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.put(`/api/task/${data.id}`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
};
export const listTasks = ({ commit }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.get('/api/task', config)
    .then((response) => {
      const tasks = response.data;
      commit('SET_TASKS', { tasks })
    },
    (error) => {
      console.log(error);
    })
};

export const addBusinessInTask = (_, { data, taskId, businessId }) => {
  return axios.post(`/api/task/${taskId}/business/${businessId}`, data)
    .catch(err => err.response)
}

export const updateBusinessInTask = (_, { data, taskId, businessId }) => {
  return axios.put(`/api/task/${taskId}/business/${businessId}`, data)
    .catch(err => err.response)
}

export const deleteBusinessInTask = (_, { taskId, businessId }) => {
  return axios.delete(`/api/task/${taskId}/business/${businessId}`)
    .catch(err => err.response)
}

export const createAllBusinessInTask =({}, {taskId, data}) =>{
  return axios.post(`/api/task/${taskId}/create-all-business-in-task`, data)
    .catch(err=> err.response);
}

export const deleteAllBusinessInTask =({}, {taskId}) =>{
  return axios.delete(`/api/task/${taskId}/delete-all-business-in-task`)
    .catch(err=> err.response);
}
